/**
 * @file        ls-storage.js - implementations for sessionStorage and localStorage used internally by
 *              the identity module
 *
 * @author      Wes Garland
 * @date        June 2024
 */
'use strict';

const { isBrowserPlatform }   = require('dcp/common/dcp-env');

if (isBrowserPlatform)
{
  exports.localStorage = window.localStorage;
  exports.sessionStorage = window.sessionStorage;
}
else
{
  const ss = {};
  
  exports.localStorage = require('dcp/common/dcp-localstorage').localStorage;
  exports.sessionStorage = {
    setItem:    (item, value) => ss[item] = value,
    removeItem: (item)        => ss[item] = undefined,
    getItem:    (item)        => ss[item],
  }
}
